'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = require('react-redux');

var _AddByEanCells = require('../components/AddByEanCells');

var _AddByEanCells2 = _interopRequireDefault(_AddByEanCells);

var _CartTableRow = require('../components/CartTableRow');

var _CartTableRow2 = _interopRequireDefault(_CartTableRow);

var _localize = require('linksoft/utils/localize');

var _localize2 = _interopRequireDefault(_localize);

var _actions = require('../actions');

var _actions2 = _interopRequireDefault(_actions);

var _StockAvailibilitySortPopup = require('./StockAvailibilitySortPopup.js');

var _StockAvailibilitySortPopup2 = _interopRequireDefault(_StockAvailibilitySortPopup);

var _linksoftAlbatros = require('linksoft-albatros');

var _DeleteSelectedButtonRow = require('../components/DeleteSelectedButtonRow');

var _DeleteSelectedButtonRow2 = _interopRequireDefault(_DeleteSelectedButtonRow);

var _DeleteSelectedButtonCells = require('../components/DeleteSelectedButtonCells');

var _DeleteSelectedButtonCells2 = _interopRequireDefault(_DeleteSelectedButtonCells);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var mapDispatchToProps = {
    sortItems: _actions2.default.sortItems
};

var CartTable = (_dec = (0, _reactRedux.connect)(null, mapDispatchToProps), _dec(_class = (_temp = _class2 = function (_Component) {
    (0, _inherits3.default)(CartTable, _Component);

    function CartTable(props) {
        (0, _classCallCheck3.default)(this, CartTable);

        var _this = (0, _possibleConstructorReturn3.default)(this, (CartTable.__proto__ || (0, _getPrototypeOf2.default)(CartTable)).call(this, props));

        _this.state = {
            showSortOptions: false
        };
        return _this;
    }

    (0, _createClass3.default)(CartTable, [{
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            var items = nextProps.items;


            if (items.length === 0) {
                // remove loading
                $('#loadingTr', document).remove();
            }
        }
    }, {
        key: 'resolveSortOptions',
        value: function resolveSortOptions(setVisible, event) {
            this.setState({ showSortOptions: setVisible });
            if (event) event.stopPropagation();
        }
    }, {
        key: 'getSelectionClassForIcon',
        value: function getSelectionClassForIcon(sortKey, originalClass) {
            return originalClass + ' ' + (sortKey === this.props.sortByProp ? 'selected' : '');
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var _props = this.props,
                _props$totalPrice = _props.totalPrice,
                totalPrice = _props$totalPrice === undefined ? {} : _props$totalPrice,
                canChangeCart = _props.canChangeCart,
                canSeeRabat = _props.canSeeRabat,
                items = _props.items,
                _props$hideAddByEan = _props.hideAddByEan,
                hideAddByEan = _props$hideAddByEan === undefined ? false : _props$hideAddByEan,
                _props$itemArgs = _props.itemArgs,
                itemArgs = _props$itemArgs === undefined ? {} : _props$itemArgs,
                _props$prefix = _props.prefix,
                prefix = _props$prefix === undefined ? '' : _props$prefix,
                sortByProp = _props.sortByProp,
                sortDirection = _props.sortDirection,
                cart = _props.cart;


            var sortKeys = {
                available: 'amountAvailable',
                comission: 'commissionAmount',
                processing: 'amountForProcessing',
                onTheWay: 'amountOnTheWay'
            };

            var sortingClass = sortDirection === 'desc' ? 'sorting_desc' : 'sorting_asc';

            // render entire cart
            return _react2.default.createElement(
                'div',
                { className: 'table-responsive' },
                _react2.default.createElement(
                    'table',
                    { className: 'table products-view-table products-view-table--cart table-cart' },
                    _react2.default.createElement(
                        'thead',
                        null,
                        _react2.default.createElement(
                            'tr',
                            null,
                            _react2.default.createElement(
                                'th',
                                { className: sortByProp === 'productName' ? sortingClass : 'sorting', onClick: function onClick(e) {
                                        return _this2.sort('productName');
                                    } },
                                (0, _localize2.default)("App:ProductName"),
                                ' / ',
                                (0, _localize2.default)("App:Author")
                            ),
                            _react2.default.createElement('th', null),
                            _react2.default.createElement(
                                'th',
                                { className: sortByProp === 'ean' ? sortingClass : 'sorting', onClick: function onClick(e) {
                                        return _this2.sort('ean');
                                    } },
                                (0, _localize2.default)("App:Ean")
                            ),
                            _react2.default.createElement(
                                'th',
                                { className: 'text-center' },
                                (0, _localize2.default)("App:Amount")
                            ),
                            _react2.default.createElement(
                                'th',
                                { className: 'icons clickable',
                                    id: 'stockAvailability',
                                    onClick: function onClick(e) {
                                        return _this2.resolveSortOptions(true, e);
                                    } },
                                _react2.default.createElement(_StockAvailibilitySortPopup2.default, { key: 'availibilitySort',
                                    showSort: this.state.showSortOptions,
                                    closePopup: function closePopup(e) {
                                        return _this2.resolveSortOptions(false, e);
                                    },
                                    sortFunction: function sortFunction(propName, direction) {
                                        return _this2.sort(propName, direction);
                                    },
                                    sortByProp: this.props.sortByProp,
                                    sortKeys: sortKeys
                                }),
                                _react2.default.createElement(
                                    'div',
                                    { className: 'sortingHeader' },
                                    _react2.default.createElement(
                                        'span',
                                        { className: this.getSelectionClassForIcon(sortKeys.available, "small") },
                                        (0, _localize2.default)("Common:InStock")
                                    ),
                                    _react2.default.createElement('br', null)
                                )
                            ),
                            canSeeRabat ? _react2.default.createElement(
                                'th',
                                { className: 'text-right' },
                                (0, _localize2.default)("App:Discount")
                            ) : null,
                            _react2.default.createElement(
                                'th',
                                { className: 'text-right' },
                                (0, _localize2.default)("Common:Price"),
                                '/ ',
                                (0, _localize2.default)("App:AmountPreOrder"),
                                _react2.default.createElement('br', null),
                                (0, _localize2.default)("App:WithVat")
                            ),
                            _react2.default.createElement(
                                'th',
                                { className: 'text-right' },
                                (0, _localize2.default)("Common:Total"),
                                _react2.default.createElement('br', null),
                                (0, _localize2.default)("App:WithoutVat")
                            ),
                            _react2.default.createElement(
                                'th',
                                { className: 'text-right' },
                                (0, _localize2.default)("Common:Total"),
                                _react2.default.createElement('br', null),
                                (0, _localize2.default)("App:WithVat")
                            ),
                            _react2.default.createElement(
                                'th',
                                { style: { width: 'auto' } },
                                '\xA0'
                            )
                        )
                    ),
                    _react2.default.createElement(
                        'tbody',
                        null,
                        _react2.default.createElement(
                            'tr',
                            { id: 'loadingTr' },
                            _react2.default.createElement(
                                'td',
                                { colSpan: '10' },
                                _react2.default.createElement('div', { className: 'cart__loading' })
                            )
                        ),
                        items.map(function (item) {
                            return _react2.default.createElement(_CartTableRow2.default, (0, _extends3.default)({
                                key: prefix + 'product_' + item.productId,
                                item: item,
                                canChangeCart: canChangeCart,
                                canSeeRabat: canSeeRabat
                            }, itemArgs));
                        })
                    ),
                    _react2.default.createElement(
                        'tfoot',
                        null,
                        !hideAddByEan && canChangeCart ? _react2.default.createElement(
                            'tr',
                            null,
                            _react2.default.createElement(_AddByEanCells2.default, null),
                            _react2.default.createElement(_DeleteSelectedButtonCells2.default, { cart: cart })
                        ) : _react2.default.createElement(_DeleteSelectedButtonRow2.default, { cart: cart }),
                        _react2.default.createElement(
                            'tr',
                            { className: 'table-summary-last-row' },
                            _react2.default.createElement(
                                'td',
                                { colSpan: canSeeRabat ? "7" : "6" },
                                _react2.default.createElement(
                                    'strong',
                                    null,
                                    (0, _localize2.default)("Common:Total")
                                )
                            ),
                            _react2.default.createElement(
                                'td',
                                { className: 'text-right' },
                                _react2.default.createElement(
                                    'span',
                                    { className: 'nowrap' },
                                    (0, _linksoftAlbatros.formatPrice)(totalPrice.finalPriceWithoutVat, _linksoftAlbatros.PriceType.CartTotalPriceWithoutVat)
                                )
                            ),
                            _react2.default.createElement(
                                'td',
                                { className: 'text-right' },
                                _react2.default.createElement(
                                    'strong',
                                    { className: 'nowrap' },
                                    (0, _linksoftAlbatros.formatPrice)(totalPrice.finalPrice, _linksoftAlbatros.PriceType.CartTotalPrice)
                                )
                            ),
                            _react2.default.createElement('td', null)
                        )
                    )
                )
            );
        }
    }, {
        key: 'sort',
        value: function sort(propName, direction) {
            var _props2 = this.props,
                sortByProp = _props2.sortByProp,
                sortDirection = _props2.sortDirection,
                sortItems = _props2.sortItems;

            if (!direction) {
                direction = sortByProp === propName ? sortDirection === 'desc' ? 'asc' : 'desc' :
                // sort ascending after first column click
                'asc';
            }
            sortItems(propName, direction);
        }
    }]);
    return CartTable;
}(_react.Component), _class2.propTypes = {
    items: _propTypes2.default.array.isRequired,
    totalPriceWithoutVat: _propTypes2.default.number,
    totalPriceWithVat: _propTypes2.default.number,
    canChangeCart: _propTypes2.default.bool.isRequired,
    canSeeRabat: _propTypes2.default.bool,
    sortByProp: _propTypes2.default.string,
    sortDirection: _propTypes2.default.string,
    sortItems: _propTypes2.default.func.isRequired,
    cart: _propTypes2.default.object
}, _temp)) || _class);
exports.default = CartTable;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./Scripts/app/cart/components/CartTable.js
// module id = 903
// module chunks = 0